import { render, staticRenderFns } from "./RenderChildrens.vue?vue&type=template&id=596fa651&"
import script from "./RenderChildrens.vue?vue&type=script&lang=js&"
export * from "./RenderChildrens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596fa651')) {
      api.createRecord('596fa651', component.options)
    } else {
      api.reload('596fa651', component.options)
    }
    module.hot.accept("./RenderChildrens.vue?vue&type=template&id=596fa651&", function () {
      api.rerender('596fa651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/RenderChildrens.vue"
export default component.exports